import { Text, Icon } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'

const NoResults: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div
      className="my-auto p-6 max-w-[600px] mx-auto text-center"
      data-testid="collection-no-results"
    >
      <div className="inline-block p-4 bg-surface-primary-default rounded-circle mb-6">
        <Icon.Search className="w-8 h-8" />
      </div>
      <Text variant="title-four" className="mb-4">
        {t('collection.no_results_title')}
      </Text>
      <Text variant="body-md" className="mt-2">
        {t('collection.no_results_description')}
      </Text>
    </div>
  )
}

export { NoResults }
